/**
 * data -> object = para montar o slide {img (required), title, subtitle, color}
 * autoPlay -> bool = para fazer o carrousel girar automaticamente
 * autoPlayDuration -> number = duração do slide (mileseconds)
 * blockAutoPlayRepeat -> true = bloquear o retorno automático quando for auto play
 * isCircle -> bool = fazer o carrousel rodar indeterminado 
 * isFade -> bool = aplicar fade nos itens não ativos
 */
import React, { useMemo, useRef } from "react";
import './Slide.css'
import Flicking, { ViewportSlot } from "@egjs/react-flicking";
import { Pagination, AutoPlay, Fade } from "@egjs/flicking-plugins";
import "@egjs/react-flicking/dist/flicking.css";
import "@egjs/flicking-plugins/dist/pagination.css";
import getImage from "../../useFull/getImage";

const SlideItem = (d, i) => {
  const img = getImage('slide-images', d.image);
  if(!img) return 
  return (
    <div className="slide-item-container" key={i} style={{ backgroundImage: `url(${img})` }}>
      <div>
        <span dangerouslySetInnerHTML={{ __html: d.subtitle }} className={`text-subtitle-slide white100`}></span>
        <span dangerouslySetInnerHTML={{ __html: d.title }} className={`text-title-secondary white100`}></span>
      </div>
    </div>
  )
}

const Slide = (props) => {
  const flickingRef = useRef(null);
  const { data, autoPlay, isCircle, isFade, autoPlayDuration, blockAutoPlayRepeat } = props

  const plugins = useMemo(() => [
    new Pagination({ type: 'scroll' }),
    ...(isFade ? [new Fade()] : []),
    ...(autoPlay ? [ new AutoPlay({ duration: autoPlayDuration || 5000, direction: 'NEXT', stopOnHover: true, delayAfterHover: 1000 })] : [])
  ], [isFade, autoPlay, autoPlayDuration]);


  const handleReachEnd = (e) => {
    if(isCircle || blockAutoPlayRepeat) return
    if (e.prevIndex === 1) {
      setTimeout(() => {
        flickingRef.current.moveTo(0, 700);
      }, autoPlayDuration || 5000);
    }
  };

  return (
    <div className="slide-container">
      <Flicking ref={flickingRef} plugins={plugins} circular={isCircle && !blockAutoPlayRepeat} onChanged={(handleReachEnd)}>
        {data.map((d, i) => {
          return SlideItem(d, i)
        })}

        <ViewportSlot>
          <div className="flicking-pagination custom-flicking-pagination">
          </div>
        </ViewportSlot>
      </Flicking>
    </div>
  )
}

export default Slide